import { render } from "./DownloadReportDialog.vue?vue&type=template&id=ec1494ae&scoped=true&ts=true&lang=pug"
import script from "./DownloadReportDialog.vue?vue&type=script&lang=ts"
export * from "./DownloadReportDialog.vue?vue&type=script&lang=ts"

import "./DownloadReportDialog.vue?vue&type=style&index=0&id=ec1494ae&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Sultan/CMS Admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec1494ae"]])

export default __exports__